export const SETMETTINGVIPSTORES = 'SETMETTINGVIPSTORES'